import { useTranslation } from 'react-i18next';
import React from 'react';

interface LoadingIndicatorProps {
  style?: React.CSSProperties;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  style,
}) => {
  const { t } = useTranslation();

  return (
    <div className="loading-section" style={style}>
      <div className="spin"></div>
      {/* <p>{t('payment_processing')}</p> */}
    </div>
  );
};

export default LoadingIndicator;
